import React, { useRef } from 'react';
import Alert from '../components/ui/Alert';
import LoadingSpinner from '../components/ui/LoadingSpinner';
import useAppDispatch from '../hooks/use-app-dispatch';
import { useAppSelector } from '../hooks/use-app-selector';
import { authActions } from '../store/auth';

const LoginPage: React.FC = (): React.ReactElement => {
  const dispatch = useAppDispatch();
  const loginRef = useRef<HTMLInputElement>(null);
  const senhaRef = useRef<HTMLInputElement>(null);

  const { error, status } = useAppSelector((state) => state.auth);

  const loginClickHandler = (event: React.MouseEvent) => {
    event.preventDefault();
    dispatch(
      authActions.fetchToken({ login: loginRef.current?.value, senha: senhaRef.current?.value })
    );
  };

  return (
    <div className="container-fluid vh-100 mt-5">
      <div className="">
        <div className="rounded d-flex justify-content-center">
          <div className="col-md-4 col-sm-12 shadow-lg p-5 bg-light">
            {error && status === 'completed' && <Alert message={error} type="danger" />}

            <div className="text-center">
              <h3 className="text-primary">Login</h3>
            </div>

            <form action="">
              <div className="p-4">
                <div className="input-group mb-3">
                  <span className="input-group-text bg-primary">
                    <i className="bi bi-person-plus-fill text-white"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Nome de usuário"
                    ref={loginRef}
                    autoFocus
                  />
                </div>
                <div className="input-group mb-3">
                  <span className="input-group-text bg-primary">
                    <i className="bi bi-key-fill text-white"></i>
                  </span>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Senha"
                    ref={senhaRef}
                  />
                </div>
                <button
                  className="btn btn-primary text-center mt-2"
                  type="submit"
                  onClick={loginClickHandler}
                  disabled={status === 'pending'}
                >
                  Login
                </button>
                {status === 'pending' && <LoadingSpinner />}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default LoginPage;
